import { ChangeDetectionStrategy, Component, EventEmitter, Output } from "@angular/core";

@Component({
  selector: "astrobin-image-viewer-close-button",
  template: `
    <button (click)="closeClick.emit()" class="btn btn-link text-light">
      <fa-icon class="me-0" icon="times"></fa-icon>
    </button>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImageViewerCloseButtonComponent {
  @Output() closeClick = new EventEmitter<void>();
}
